import { createAsyncThunk } from '@reduxjs/toolkit';

import { FilterService } from 'api';

export const getFilters = createAsyncThunk('primaryMarket/getFilters', async () => {
	return await FilterService.get();
});
